import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import MuiTypography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

const styles = theme => ({
  root: {
    letterSpacing: 0,
    opacity: 1
  }
});

const getFontFamily = type => {
  switch (type) {
    case "heading1":
      return "Open Sans";
    case "heading2":
      return "Open Sans";
    case "heading3":
      return "Open Sans";
    case "heading4":
      return "Open Sans";
    case "heading5":
      return "Open Sans";
    case "headLine":
      return "Open Sans";
    case "button":
      return "Open Sans";
    case "title":
      return "Open Sans";
    case "subHeader":
      return "Open Sans";
    case "button":
      return "Open Sans";
    default:
      return "Open Sans";
  }
};

const getFontSize = type => {
  switch (type) {
    case "heading1":
      return "32px";
    case "heading2":
      return "24px";
    case "heading3":
      return "18px";
    case "heading4":
      return "16px";
    case "heading5":
      return "14px";
    case "body1":
      return "18px";
    case "body2":
      return "16px";
    case "body3":
      return "14px";
    case "body4":
      return "12px";
    case "quote":
      return "20px";
    case "button":
      return "14px";

    default:
      return "14px";
  }
};

const getFontWeight = type => {
  switch (type) {
    case "heading1":
      return "600";
    case "heading2":
      return "600";
    case "heading3":
      return "600";
    case "heading4":
      return "600";
    case "heading5":
      return "600";
    case "body1":
      return "400";
    case "body2":
      return "400";
    case "body3":
      return "400";
    case "body4":
      return "400";
    case "quote":
      return "600";
    case "button":
      return "600";
    case "bold":
      return "800";

    default:
      return "400";
  }
};

const Typography = props => {
  const { classes } = props;
  //Log(props);
  const { color, ...passedProps } = props;
  const getColor = type => {
    if (props.currentTheme === "dark") {
      return "#ffffff";
    } else {
      switch (type) {
        case "heading1":
          return "#000000";
        case "heading2":
          return "#000000";
        case "heading3":
          return "#000000";
        case "heading4":
          return "#000000";
        case "heading5":
          return "#000000";
        case "button":
          return "#FFFFFF";

        default:
          return "#000000";
      }
    }
  };
  return (
    <MuiTypography
      className={classes.root}
      style={{
        cursor: props.cursor ? props.cursor : "default",
        fontFamily: props.fontFamily
          ? props.fontFamily
          : getFontFamily(props.type),
        fontSize: props.fontSize ? props.fontSize : getFontSize(props.type),
        fontWeight: props.fontWeight
          ? props.fontWeight
          : getFontWeight(props.type),
        color: props.color ? props.color : getColor(props.type),
        letterSpacing: "0.04em"
      }}
      {...passedProps}
    >
      {props.children}
    </MuiTypography>
  );
};

Typography.propTypes = {
  type: PropTypes.string
};

Typography.defaultProps = {
  type: "body"
};

export default withStyles(styles)(Typography);
